export default __webpack_public_path__ + "static/membership-control-promo-4ae111a6d0fd0fe3bcc00935bc4edf71.jpg";